define('util/core',[ "exports" ], function( exports ) {

	"use strict";

	var Arr = Array;

	if ( "isArray" in Arr ) {
		exports.isArray = Arr.isArray;
	} else {
		exports.isArray = (function( toString ) {
			return function( obj ) {
				return toString.call( obj ) === "[object Array]";
			}
		}( Object.prototype.toString ));
	}

	if ( "foreach" in Arr.prototype ) {
		exports.forEach = function( arr, fn, context ) {
			arr.forEach( fn, context );
		}
	} else {
		exports.forEach = function( arr, fn, context ) {
			var
				i = 0,
				n = arr.length;

			for ( ; i !== n ; ++i ) {
				fn.call( context, arr[ i ], i, arr );
			}
		}
	}

	if ( "map" in Arr.prototype ) {
		exports.map = function( arr, fn, context ) {
			return arr.map( fn, context );
		}
	} else {
		exports.map = function( arr, fn, context ) {
			var
				i   = 0,
				n   = arr.length,
				out = new Arr( n );

			for ( ; i !== n ; ++i ) {
				out[ i ] = fn.call( context, arr[ i ], i, arr );
			}

			return out;
		}
	}
});
define('util', ['util/core'], function (main) { return main; });

